import { useFormikContext } from 'formik';
import React, { useEffect } from 'react'


function DrgWatcher({ methodTypes, isFeeScheduleDrg, isCodeServiceDrg, isDrgCodeSelectionType, setIsDrgCodeSelectionType }) {
  const { values, setFieldValue } = useFormikContext<any>();

  useEffect(() => {
    if (values.codeSelectionType === 'Codes' && values.methodId) {
      const methodType = methodTypes?.find(m => m.id === values.methodId);
      const isDrg = methodType?.name === 'DRG';

      setIsDrgCodeSelectionType(isDrg);

    //   if (isDrg && !values.isAlosEnabled) {
    //     setFieldValue('isAlosEnabled', true);
    //   } else 
    if (!isDrg && values.isAlosEnabled) {
        setFieldValue('isAlosEnabled', false);
      }
    } else if (values.codeSelectionType === 'Fee Schedule' && values.feeScheduleId) {
      isFeeScheduleDrg(values.feeScheduleId, (result) => {
        setIsDrgCodeSelectionType(result);

        // if (result && !values.isAlosEnabled) {
        //   setFieldValue('isAlosEnabled', true);
        // } else 
        if (!result && values.isAlosEnabled) {
          setFieldValue('isAlosEnabled', false);
        }
      });
    } else if (values.codeSelectionType === 'Code Service' && values.codeServiceId) {
      isCodeServiceDrg(values.codeServiceId, (result) => {
        setIsDrgCodeSelectionType(result);

        // if (result && !values.isAlosEnabled) {
        //   setFieldValue('isAlosEnabled', true);
        // } else 
        if (!result && values.isAlosEnabled) {
          setFieldValue('isAlosEnabled', false);
        }
      });
    } else {
      setIsDrgCodeSelectionType(false);
      if (values.isAlosEnabled) {
        setFieldValue('isAlosEnabled', false);
      }
    }
  }, [values.codeSelectionType, values.methodId, values.feeScheduleId, values.codeServiceId]);

  return null;
}

export default DrgWatcher